import { createFileRoute, notFound } from "@tanstack/react-router";
import { ESTATE_QA, ESTATE_QA_BY_SLUG, ESTATE_REVIEWED_ISO, ESTATE_REVIEWED_TH } from "@/data/estate/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = { base: "/estate", label: "พินัยกรรมและมรดก", reviewedIso: ESTATE_REVIEWED_ISO, reviewedTh: ESTATE_REVIEWED_TH };

export const Route = createFileRoute("/estate/q/$slug")({
  loader: ({ params }) => { if (!ESTATE_QA_BY_SLUG[params.slug]) throw notFound(); return { slug: params.slug }; },
  head: ({ loaderData }) => clusterQaDetailHead(M, loaderData ? ESTATE_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = ESTATE_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={ESTATE_QA} />;
}
